import APP_ACTIONS from '../constants/app-actions';
import LineItemsModel from '../services/line-items';
import MunicipalityService from '../services/municipality-service';

const initialState = {
    addingProductToCart: false,
    removingProductToCart: false,
    disablingAdd: false,
    shipments: [],
    line_items: [],
    lastDate: null,
    checkout_steps: [
        'address',
        'delivery',
        'payment',
        'complete',
    ],
    redsysPaymentInfo: {},
    redsysPaymentError: false,
    isFinalStepHappening: false,
    isCreditCardValidated: false,
};

const order = (state = initialState, action) => {
    const items = [];
    let lineItems = [];
    let newLineItems = Object.assign([], state.line_items);

    switch (action.type) {
    case APP_ACTIONS.CREATE_ORDER:
        return { ...state, ...action.payload };

    case APP_ACTIONS.ADD_PRODUCT_TO_CART:
    case APP_ACTIONS.UPDATE_ORDER:
    case APP_ACTIONS.REMOVE_DATA_EXTRA_ITEM:
    case APP_ACTIONS.UPDATE_LINE_ITEM:
        lineItems = LineItemsModel.lineItems(action.payload.data.relationships.line_items.data.map((a) => a.id), action.payload.included);
        lineItems.forEach((item) => {
            item.variant = LineItemsModel.variant(item.relationships.variant.data.id, action.payload.included);
            item.variant.images = LineItemsModel.images(item.variant.relationships.images.data.map((a) => a.id), action.payload.included);
            item.data_extras = LineItemsModel.data_extras(item.relationships.data_extras.data.map((a) => a.id), action.payload.included);
            item.data_extra_types = LineItemsModel.data_extra_types(item.data_extras.map((a) => a.attributes.type_id), action.payload.included);

            const product = LineItemsModel.product(item.variant.relationships.product.data.id, action.payload.included);
            item.shipping_category = product.attributes.shipping_category;
            if (item.variant.images.length === 0) {
                item.variant.images = LineItemsModel.images(product.relationships.images.data.map((a) => a.id), action.payload.included);
            }
            items.push(item);
        });
        const municipalityInfo = MunicipalityService.getMunicipalityInfoFromOrderResponse(action.payload);
        return {
            ...state,
            ...action.payload.data.attributes,
            id: action.payload.data.id,
            line_items: items,
            lastDate: new Date(),
            bill_address: {
                id: action.payload.data.bill_address && action.payload.data.bill_address.id,
                ...action.payload.data.bill_address && action.payload.data.bill_address.attributes,
            },
            ship_address: {
                id: action.payload.data.ship_address && action.payload.data.ship_address.id,
                ...action.payload.data.ship_address && action.payload.data.ship_address.attributes,
            },
            shipments: action.payload.data.shipments,
            user: {
                id: action.payload.data.user && action.payload.data.user.id,
                ...action.payload.data.user && action.payload.data.user.attributes,
            },
            ...(municipalityInfo && ({ municipalityInfo })),
        };

    case APP_ACTIONS.REMOVE_LINE_ITEM:
        newLineItems = newLineItems.filter((lineItem) => lineItem.id !== action.payload);

        return {
            ...state,
            line_items: newLineItems,
        };

    case APP_ACTIONS.ADD_PAYMENT_METHOD:
        return {
            ...state,
            payment_methods: action.payload,
        };

    case APP_ACTIONS.ADDING_PRODUCT_TO_CART:
        return {
            ...state,
            addingProductToCart: !state.addingProductToCart,
        };

    case APP_ACTIONS.ADDING_PRODUCT_TO_CART_TO_FIX:
        return {
            ...state,
            addingProductToCart: action.payload,
        };

    case APP_ACTIONS.REMOVING_PRODUCT_TO_CART:
        return {
            ...state,
            removingProductToCart: action.payload,
        };
    case APP_ACTIONS.SET_IS_FINAL_STEP_HAPPENING:
        return {
            ...state,
            isFinalStepHappening: action.payload,
        };
    case APP_ACTIONS.SYNC_ORDER_FROM_STORAGE:
        return {
            ...action.payload,
        };
    case APP_ACTIONS.DISABLING_ADD:
        return {
            ...state,
            disablingAdd: action.payload,
        };

    case APP_ACTIONS.ADD_REDSYS_PAYMENT_INFO:
        return { ...state, redsysPaymentInfo: action.payload };

    case APP_ACTIONS.ADD_REDSYS_PAYMENT_ERROR:
        return { ...state, redsysPaymentError: action.payload };

    case APP_ACTIONS.DESTROY_ORDER:
        return initialState;
    case APP_ACTIONS.VALIDATE_CREDIT_CARD:
        return { ...state, isCreditCardValidated: action.payload };
    default:
        return state;
    }
};

export default order;



/** WEBPACK FOOTER **
 ** ./src/reducers/order.js
 **/